import DataTable, { createTheme } from 'react-data-table-component';
import moment from 'moment';
import web3Config from '../../../Web3/web3Config';

export const ListTable = ({ DataList, type }) => {


    const buyColumns = [

        {
            name: 'INFI Token',
            selector: row => parseFloat(row._infiToken).toFixed(6),
            sortable: true,
        },
        {
            name: 'INFI Price ($)',
            selector: row => parseFloat(row._infiPrice).toFixed(6),
            sortable: true,
        },
        {
            name: 'USDT Amount',
            selector: row => parseFloat(row._usdtAmount).toFixed(6),
            sortable: true,
        },
        {
            name: 'Phase',
            selector: row => row._phase || 1,
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => moment(new Date(row._datetime)).format("DD/MM/YYYY HH:mm"),
            sortable: true,
        },
        {
            name: 'Trx Hash',
            selector: row => <a target='_blank' href={`${web3Config.Explore}tx/${row._hash}`}>{row._hash.substring(0, 10)}...</a>,
            sortable: true,
        },
    ];

    const claimColumns = [

        {
            name: 'INFI Token',
            selector: row => parseFloat(row._infiToken).toFixed(6),
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => moment(new Date(row._datetime)).format("DD/MM/YYYY HH:mm"),
            sortable: true,
        },
        {
            name: 'Trx Hash',
            selector: row => <a target='_blank' href={`${web3Config.Explore}tx/${row._hash}`}>{row._hash.substring(0, 10)}...</a>,
            sortable: true,
        },
    ];

    const data = [
        {
            id: 1,
            token: '#123',
            amount: '123',
            phase: '1',
            date: '24/11/2023',
            action: '...',
        },
        {
            id: 2,
            token: '#123',
            amount: '1988',
            phase: '2',
            date: '24/11/2023',
            action: '...',
        },
        {
            id: 3,
            token: '#123',
            amount: '1988',
            phase: '3',
            date: '24/11/2023',
            action: '...',
        }
    ]
    createTheme('solarized', {
        text: {
            primary: '#fff',
            secondary: '#fff',

        },
        background: {
            default: 'transparent',
        },
        context: {
            text: '#FFFFFF',
        },
        divider: {
            default: 'rgba(var(--bs-dark-rgb),var(--bs-border-opacity))'
        },
        action: {
            button: 'rgba(0,0,0,.54)',
            hover: 'rgba(0,0,0,.08)',
            disabled: 'rgba(0,0,0,.12)',
        },
    }, 'dark');

    const customStyles = {
        rows: {
            style: {
                minHeight: '50px', // override the row height
                fontSize: '1rem'
            },
        },
        head: {
            style: {
                minHeight: '50px',
                fontSize: '1rem',
                background: 'linear-gradient(90deg, #93D9AC 0%, #85DEF5 100%)'
            },
        },
        headCells: {
            style: {
                color: '#000',
                fontWeight: '600'
            },
        },
        cells: {
            style: {
                border: 'none'
            },
        },
    };

    return (
        type == 1 ?
            <DataTable
                columns={buyColumns}
                data={DataList}
                theme="solarized"
                customStyles={customStyles}
                pagination
            />
            :
            <DataTable
                columns={claimColumns}
                data={DataList}
                theme="solarized"
                customStyles={customStyles}
                pagination
            />
    )


}